import { useState } from 'react';
import PropTypes from 'prop-types';
import { Store, ShoppingBag } from 'lucide-react';
import { StorefrontPanel } from './StorefrontPanel';
import { OnlineOrdersPanel } from './OnlineOrdersPanel';
import { ROLES } from '../../data/store';
import { useSharedStore } from '../../hooks/useSharedStore';

export const EcommerceTab = ({ org, role, showNotification }) => {
  useSharedStore();
  const canManageStore = role === ROLES.ORG_ADMIN;
  const [view, setView] = useState(canManageStore ? 'storefront' : 'orders');
  const accent = org.theme.primary;

  // Staff who cannot manage the storefront only work the online orders board.
  if (!canManageStore) {
    return <OnlineOrdersPanel org={org} showNotification={showNotification} />;
  }

  return (
    <div className="flex flex-col gap-4">
      <section className="bg-white border border-[var(--theme-tertiary)] rounded-lg px-5 py-3">
        <div className="flex items-center gap-1 bg-[var(--theme-secondary)] rounded-full p-1 text-xs font-semibold uppercase tracking-[0.14em] w-max">
          {[
            { id: 'storefront', label: 'Storefront', icon: Store },
            { id: 'orders', label: 'Online Orders', icon: ShoppingBag },
          ].map((t) => (
            <button key={t.id} type="button" onClick={() => setView(t.id)}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-colors"
              style={view === t.id ? { background: accent, color: '#fff' } : { color: '#64748b' }}>
              <t.icon size={12} aria-hidden="true" /> {t.label}
            </button>
          ))}
        </div>
      </section>

      {view === 'storefront'
        ? <StorefrontPanel org={org} showNotification={showNotification} canManage={canManageStore} />
        : <OnlineOrdersPanel org={org} showNotification={showNotification} />}
    </div>
  );
};

EcommerceTab.propTypes = {
  org: PropTypes.object.isRequired,
  role: PropTypes.string,
  showNotification: PropTypes.func,
};
